import {monolithPost} from './fetch'

export const createVendor = (payload) => monolithPost('/ajax/vendors', payload)

export const createVendorAddress = (payload, vendorId) =>
  monolithPost(`/ajax/vendors/${vendorId}/address/`, payload)
